import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MDBDataTable } from 'mdbreact';
import Tooltip from '../../common/toolTip';
import PushNotificationAdd from './add';
import PushNotificationDelete from './delete';
import axios from 'axios';
import { baseUrl, ROUTE_BASE_URL } from '../../../api/common';
import dayjs from "dayjs";
import { showToast,ToastMessage } from '../../Shared/ToastMessage';
import { useUser } from '../../AdminUsers/UserContext';
const PushNotification = () => {
    const { checkPermission } = useUser();
    const [addPopupStatus, setAddPopupStatus] = useState(false);

    const [updateData, setUpdateData] = useState({});

    const [eventType, setEventType] = useState('');

    const handleAddPopup = async(status, type, data) => {
      setUpdateData(data);
      setEventType(type);
      if(type==="Add"){
          const hasPermission = await checkPermission("Push Notification", "create");
          if (!hasPermission) return;
        }else{
          const hasPermission = await checkPermission("Push Notification", "update");
          if (!hasPermission) return;
      }
      setAddPopupStatus(status);
      setViewPopupStatus(false);
  };

    const [viewPopupStatus, setViewPopupStatus] = useState(false);
    
    const handleViewPopup = (type,data) => {
        setUpdateData(data);
        setEventType(type);
        setViewPopupStatus(true);
    };

    const handleViewPopupClose = () => {
        setEventType('');
        setUpdateData({});
        setViewPopupStatus(false);
    };

    const [deletePopupStatus, setDeletePopupStatus] = useState(false);
    const [deleteId, setDeleteId] = useState();
    const handleDelete = async (id) => {
      setDeleteId(id);      
      const hasPermission = await checkPermission("Push Notification", "delete");
      if (!hasPermission) return;      
      setDeletePopupStatus(true);
    };

    const handleCloseDelete = () => {
        setDeletePopupStatus(false);
        setViewPopupStatus(false);
    };

    const [pushNotificationData, setPushNotificationData] = useState([]);

    function convertPushNotificationDate(notifyDate) {
      const date = dayjs.utc(notifyDate);
      const now = dayjs();

      if (now.diff(date, "days") > 0) {
        return date.format("DD MMM");
      }
      if (now.diff(date, "hours") > 0) {
        return `${now.diff(date, "hours")} hr`;
      }
      if (now.diff(date, "minutes") > 0) {
        return `${now.diff(date, "minutes")} minutes ago`;
      }
      if (now.diff(date, "seconds") > 0) {
        return `${now.diff(date, "seconds")} seconds ago`;
      }
      return "Just now";
    }
    function convertDBDate(dateStr) {
    if (!dateStr) return "N/A";

    const date = new Date(dateStr);

    return new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        timeZone: "UTC"
    }).format(date);
    }
    const fetchPushNotificationData = async () => {
        try {
          const response = await axios.get(
            `${baseUrl}/api/push_notification_list`,  
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: localStorage.getItem('access_token'),
              },
            }
          );
    
          if (response.data.status) {          
            setPushNotificationData(response.data.data);
          } else {
            console.error('Error: Failed to fetch user data');
          }
        } catch (error) {
          console.error('Error fetching users data:', error);
        }
    };
    const [sendPushNotificationId, setSendPushNotificationId] = useState(null);
    const sendPushNotification = async (id) => {
        setSendPushNotificationId(id);
        try {
          const response = await axios.post(
            `${baseUrl}/api/send_push_n_to_mobile`,
            { id: id },  
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: localStorage.getItem('access_token'),
              },
            }
          );
    
          if (response.data.status) {
            showToast(response.data.message, 'success');
            fetchPushNotificationData();
            handleViewPopupClose();          
          } else {
            console.error('Error: Failed to fetch user data');
          }
        } catch (error) {
          console.error('Error fetching users data:', error);
        }finally {
          setSendPushNotificationId(null);
        }
    };
    
    const body = {
        columns: [
            {
                label: 'S.No',
                field: 'sno',
                attributes: {
                    style: { width: '2%', fontWeight: 'bold' },
                },
            },
            {
                label: 'Title',
                field: 'title',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Name',
                    style: { width: '50%', fontWeight: 'bold' },
                },
           },
           {
                label: 'Message',
                field: 'description',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Name',
                    style: { width: '50%', fontWeight: 'bold' },
                },
            },
            {
                label: 'Date',
                field: 'created_on',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Name',
                    style: { width: '50%', fontWeight: 'bold' },
                },
            },
            {
                label: 'Action',
                field: 'action',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Action',
                    style: { width: '1%', fontWeight: 'bold' },
                },
            }
        ],
        rows:pushNotificationData&&pushNotificationData.map((data, index) => ({
            sno: index + 1,
            title: data.title || "N/A",
            created_on: convertDBDate(data.created_on) || "N/A",
            description: data.description || "N/A",
            action: (
                <div>
                  {/* <Tooltip text={data.send_status===1?"Send":"Re send"} id="send" /> */}
                  <button 
                    type="button" 
                    onClick={(e) => { e.stopPropagation(); sendPushNotification(data.id); }}
                    disabled={sendPushNotificationId === data.id}
                    className="btn btn-sm btn-default edit_button_package" 
                    title={data.send_status===1?"Send":"Re send"}
                  >
                    {sendPushNotificationId === data.id ? (
                        <>
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          <span className="ms-2">Sending...</span>
                        </>
                      ) : (
                        <>
                         <i className="fa fa-paper-plane"></i> {data.send_status===1?"Send":"Resend"}
                       </>
                    )}                    
                  </button>
                  {/* <Tooltip text="Delete" id="delete" /> */}
                  <button 
                    type="button" 
                    onClick={(e) => { e.stopPropagation(); handleDelete(data.id); }} 
                    className="btn btn-sm btn-default delete_button_package" 
                    title="Delete"
                    data-for="delete" 
                    data-tip
                  >
                    <i className="fa fa-trash"></i>
                  </button>
                </div>
            ),           
            clickEvent: () => handleViewPopup("Update",data),
        })),
    }
    // Check Admin User Permission
    const [checkUserLoading, setCheckUserLoading] = useState(false); 
    const fetchPermission = async () => {
      setCheckUserLoading(true);
      try {
        const hasPermission = await checkPermission("Push Notification", "view");
        if (!hasPermission) return;
      } catch (error) {
        console.error("Error fetching super specialty data:", error);
      }finally{
        setCheckUserLoading(false);
      }
    };
    useEffect(() => {
      fetchPermission();
    }, []);
    useEffect(() => {
      fetchPushNotificationData();
    }, []);

    return (
        <>
            <ToastMessage/>
            {checkUserLoading? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "500px" }}>
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
            ) : (   
            <div className="container-fluid">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h1>Push Notification Master</h1>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to={`${ROUTE_BASE_URL}/`}>AMASI</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Push Notification Master</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-md-6 col-sm-12 text-right hidden-xs">
                            <span onClick={() => handleAddPopup(true,"Add",{})} className="btn btn-outline-primary mr-1" title="">Add New</span>
                        </div>
                    </div>
                </div>
                <div className="row clearfix">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="body">
                                <div className="table-responsive">
                                    <MDBDataTable
                                        noBottomColumns
                                        className="table table-hover js-basic-example dataTable table-custom spacing5"
                                        entriesOptions={[5, 10, 20]}
                                        entries={10}
                                        paging
                                        pagesAmount={5}
                                        data={body}
                                        sortRows={['title']}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <PushNotificationAdd fetchPushNotificationData={fetchPushNotificationData} eventType={eventType} updateData={updateData} addPopupStatus={addPopupStatus} handleAddPopup={handleAddPopup} />
                <PushNotificationDelete fetchPushNotificationData={fetchPushNotificationData} deleteId={deleteId} deletePopupStatus={deletePopupStatus} handleCloseDelete={handleCloseDelete}/>

                {updateData&&<div className={`extraspace_search_div search_div${viewPopupStatus ? " open" : ""}`}>
                    <div className="card member_master_sidebar_scrool">
                        <div className="member_edit_pop_flex mb-3 text-end">
                            <h3>View Push Notification</h3>
                            <div className="input-group-append d-flex gap-10">
                                <div>
                                    <button onClick={()=>handleDelete(updateData.id)} className="saveand_proced_button btn btn btn-outline-danger btn-block" type="button"><i className="icon-trash"></i> Delete </button>
                                </div>
                                <div>
                                    <button onClick={()=> sendPushNotification(updateData.id)} disabled={sendPushNotificationId === updateData.id} className="saveand_proced_button btn btn-outline-info btn-block" type="button">
                                        {sendPushNotificationId === updateData.id ? (
                                          <>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            <span className="ms-2">Sending...</span>
                                          </>
                                        ) : (
                                           <>
                                            <i className="fa fa-paper-plane"></i> {updateData.send_status===1?"Send":"Resend"}
                                           </>
                                        )} 
                                        {/* <i className="fa fa-paper-plane"></i> {updateData.send_status===1?"Send":"Resend"}  */}
                                    </button>
                                </div>
                                <span onClick={() =>handleViewPopupClose()} className="search_toggle btn btn-danger"><i className="fa fa-times"></i></span>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <div className="body  application_body_side">
                                <fieldset>
                                    <div className="row clearfix">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="body">
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <small className="text-muted"><b>Title</b> </small>
                                                            <p>{updateData.title}</p>
                                                        </div>
                                                        <div className="col-6">
                                                            <small className="text-muted"><b>Date</b> </small>
                                                            <p>{convertDBDate(updateData.created_on)}</p>
                                                        </div>
                                                        <div className="col-12">
                                                            <small className="text-muted"><b>Message</b> </small>
                                                            <p>{updateData.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>}

            </div>)}
        </>

    );

}
export default PushNotification
